import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchAttachments } from "actions/attachment";
import { fetchMerchantAccountTaxRates } from "actions/taxRate";
import { fetchMerchantAccountShippingRates } from "actions/shippingRate";
import {
  fetchMerchantAccountProductsPrices,
  fetchMerchantAccountCouponsPromotionCodes
} from "actions/merchantAccount";
import { fetchAppCheckout } from "actions/app";
import { ensureResources } from "utils/hooks";

const ResourcesContainer = ({ actions, children }) => {
  const {
    products,
    prices,
    coupons,
    taxRates,
    shippingRates
  } = ensureResources(actions);

  return children({
    products,
    prices,
    coupons,
    taxRates,
    shippingRates
  });
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchAppCheckout,
      fetchMerchantAccountProductsPrices,
      fetchMerchantAccountCouponsPromotionCodes,
      fetchMerchantAccountTaxRates,
      fetchMerchantAccountShippingRates,
      fetchAttachments
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(ResourcesContainer);
